import { Package, MapPin, MessageCircle, Sparkles } from 'lucide-react';

/** کارت‌های شناور Hero — چیدمان دقیق اطراف متن مرکزی (desktop) */
export const LANDING_HERO_FLOATS = [
  {
    id: 'products',
    variant: 'stat',
    statKey: 'hero.stats.products',
    labelKey: 'hero.stats.productsLabel',
    icon: Package,
    position: 'top-[4%] start-[0.5%] xl:start-[2%]',
    delay: '0s',
  },
  {
    id: 'cities',
    variant: 'feature',
    titleKey: 'hero.stats.citiesTitle',
    descKey: 'hero.stats.citiesLabel',
    icon: MapPin,
    position: 'top-[2%] end-[0.5%] xl:end-[2%]',
    delay: '0.65s',
  },
  {
    id: 'contact',
    variant: 'visual',
    titleKey: 'hero.stats.contactTitle',
    descKey: 'hero.stats.contactLabel',
    icon: MessageCircle,
    sparkId: 'heroSparkContact',
    position: 'bottom-[6%] start-[1%] xl:start-[3%]',
    delay: '1.25s',
  },
  {
    id: 'free',
    variant: 'feature-bars',
    titleKey: 'hero.stats.freeTitle',
    descKey: 'hero.stats.freeLabel',
    icon: Sparkles,
    position: 'bottom-[4%] end-[1%] xl:end-[3%]',
    delay: '1.85s',
  },
];
